import type { Pole } from '../../types';

// Chips de filtre par pôle (mono-sélection + option « Tous »). Couleur du
// pôle en pastille inline (seule exception autorisée aux couleurs en dur —
// CLAUDE.md §Frontend rules).
export function PoleChips({ poles, selected, onSelect }: {
  poles: Pole[];
  selected: number | null;
  onSelect: (poleId: number | null) => void;
}) {
  return (
    <div className="filter-chips">
      <button type="button" className={`chip ${selected == null ? 'active' : ''}`} onClick={() => onSelect(null)}>
        Tous
      </button>
      {poles.map((p) => (
        <button
          key={p.id}
          type="button"
          className={`chip ${selected === p.id ? 'active' : ''}`}
          onClick={() => onSelect(p.id)}
        >
          <span className="pole-dot" style={{ background: p.couleur ?? '#999', marginRight: 6 }} />
          {p.nom}
        </button>
      ))}
    </div>
  );
}

/** Pastille de pôle + nom, pour les cellules de tableau. */
export function PoleBadge({ nom, couleur }: { nom?: string | null; couleur?: string | null }) {
  if (!nom) return <span className="text-muted">—</span>;
  return (
    <span className="inline-flex items-center gap-4">
      <span className="pole-dot" style={{ background: couleur ?? '#999' }} />
      {nom}
    </span>
  );
}
